import { handleLoginService } from '../../../Services/handleLocalStorage';

class Request {
    constructor({ url, data, headers, method }) {
        this.url = url;
        this.data = data;
        this.headers = headers || this.getHeaders();
        this.method = method;
    }
}

Request.prototype.getHeaders = function() {
    const _headers = {};

    if (handleLoginService.getUserId() && handleLoginService.getAccessToken()) {
        _headers['Authorization'] = `Bearer ${handleLoginService.getAccessToken()}`;
    }

    _headers['Content-Type'] = 'application/json';
    _headers['Access-Control-Allow-Origin'] = '*';

    return _headers;
};

class RequestFactory {}

RequestFactory.prototype.request = Request;

RequestFactory.prototype.createRequest = function(requestBody) {
    const _requestBody = {};

    _requestBody['url'] = requestBody.url;
    _requestBody['data'] = requestBody.data;
    _requestBody['method'] = requestBody.method;

    if (typeof requestBody.data === 'undefined') delete _requestBody['data'];

    return new this.request(_requestBody);
};

export const requestFactory = new RequestFactory();



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/RequestFactory/index.js